import { Injectable } from '@angular/core';
import { ApiService, CommonService } from '.';
import { apiBase } from '../../enums';


@Injectable({
    providedIn: 'root'
})
export class CommonAPIService {
    data: any;
    button: any;
    buttonJobcard: any;
    id: any;
    constructor(
        private apiService: ApiService,
        private commonService: CommonService
    ) { }

    /**
     * Call Get Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    getCall = async (name = "", value = "", nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                if (value === "") {
                    return await this.apiService.getCall(apiBase[name]);
                } else {
                    return await this.apiService.getCall(apiBase[name] + value);
                }
            }
        }
    };

    /**
     * Call Post Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    postCall = async (name = "", value = {}, nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.postCall(apiBase[name], JSON.stringify(value));
            }
        }
    };

    postCallFormData = async (name = "", formData = {}, nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.postFormCall(apiBase[name], formData);
            }
        }
    };

    /**
     * Call Delete Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    deleteCall = async (name = "", value = '', nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                if (value === "") {
                    return await this.apiService.deleteCall(apiBase[name], true);
                } else {
                    return await this.apiService.deleteCall(apiBase[name], JSON.stringify(value));
                }
            }
        }
    };


    /**
     * Call Delete Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    patchCall = async (name = "", value = '', nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                if (value === "") {
                    return await this.apiService.patchCall(apiBase[name]);
                } else {
                    return await this.apiService.patchCall(apiBase[name] + '/' + value);
                }
            }
        }
    };
    /**
     * Call Put Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    putCall = async (name = "", value = {}, nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.putCall(apiBase[name], JSON.stringify(value));
            }
        }
    };


    /**
     * Call Put Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    putCallFormData = async (name = "", formData = {}, nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.putCallFormData(apiBase[name], formData);
            }
        }
    };

    /**
     * Call Post Form Method and return a response
     *
     * @returns {Promise<any>}
     * @memberof LoginService
     */
    postFormCall = async (name = "", value: any, nameOnly = false): Promise<any> => {
        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            }
            else {
                this.commonService.resetAPIFlag(name, true);
                return await this.apiService.putCall(apiBase[name], value);
            }
        }
    };

    signup = async (value = {}, nameOnly = false): Promise<any> => {
        const name = "signup";

        if (nameOnly) {
            return name;
        } else {
            if (this.commonService.getAPIFlag(name)) {
                return await this.apiService.cancelCall();
            } else {
                this.commonService.resetAPIFlag(name, true);
                // const headers = {
                //     Authorization: `Bearer ${localStorage.getItem('token')}`
                // };
                return await this.apiService.postCall(apiBase[name], JSON.stringify(value));
            }
        }
    };


}
